import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'cookiesOverlay.title',
    defaultMessage: 'Cookies policy',
  },
});
